import Take3D from "../../../models/Take3D";
import {
  getTakeEndState,
  isHeldByAttachment,
} from "../../../helpers/TakeEndState";
import {
  getTakeEndActorPlaces,
  parseActorPlace,
} from "../../../helpers/SequenceStateAtNode";

export class TrainingSliceStrategy3DHelper {
  /**
   * A new take starts where the previous one ends: with the attachments its
   * interactions and sequence leave behind. A prop an actor now holds is no
   * longer placed on its position.
   */
  static updateActorProp(previousTake: Take3D, newTake: Take3D): Take3D {
    const { attachments } = getTakeEndState(previousTake);

    return {
      ...newTake,
      attachments,
      props: newTake.props.filter(
        (prop) => !isHeldByAttachment(attachments, prop.instanceId)
      ),
    };
  }

  /**
   * A new take starts with each actor where the previous one leaves it: a Send
   * Actor in its interactions or sequence moves the actor's start too. The
   * compiler only compares the takes' own settings, so without this the actor
   * would stay where the sequence sent it while the new take says otherwise.
   * Kept as is when that place isn't known (parallel branches in no fixed
   * order) or isn't a position (on a prop: the attachment carries it).
   */
  static updateActorPositions(previousTake: Take3D, newTake: Take3D): Take3D {
    const places = getTakeEndActorPlaces(previousTake);

    return {
      ...newTake,
      actors: newTake.actors.map((actor) => {
        const end = places[actor.actorId];
        if (!end?.changed || end.values.length !== 1) return actor;
        const place = parseActorPlace(end.values[0]);
        return place.kind === "position" ? { ...actor, positionId: place.positionId } : actor;
      }),
    };
  }
}
